import isMobile from 'is-mobile'

export function isNativeMobile() {
  return 'ReactNativeWebView' in window
}

export default () => {
  return isNativeMobile() || isMobile()
}
